import React from 'react'
import { Edit, SimpleForm, TextField, TextInput } from 'react-admin'

function EditPrompt(props) {
    return (
        <Edit  title='Edit Prompt'   {...props}>
            <h3>  Edit Prompt
            </h3>
            <SimpleForm  >
            <TextInput source="id" disabled />
                <TextInput source="title" multiline fullWidth />
                <TextInput source="definition" multiline fullWidth />
                <TextInput source="category" />

            </SimpleForm>
        </Edit>
    )
}

export default EditPrompt
